import { Building2, CookingPot, HardHat, Home, Sofa } from "lucide-react";

export const WHATSAPP_URL = "https://wa.me/919064919287";
export const WHATSAPP_MSG_URL =
  "https://wa.me/919064919287?text=Hi%20Swaclean,%20I%20would%20like%20to%20inquire%20about%20your%20cleaning%20services.";
export const FORM_URL = "https://forms.gle/VcGV5aKkPurJBVTx6";
export const PHONE_DISPLAY = "+91 90649 19287";
export const PHONE_TEL = "tel:+919064919287";
export const ADDRESS =
  "2nd Mile, Opposite Vishal Cinema Hall, beside Guru Sweets, Ward Number 13, Bankim Nagar, Siliguri, West Bengal 734001";
export const HOURS = "Open daily · Closes 7:00 PM";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=swaclean+Facility+Services+Bankim+Nagar+Siliguri";

export const NAV_LINKS = [
  { label: "Home", id: "home", testId: "nav-link-home" },
  { label: "Services", id: "services", testId: "nav-link-services" },
  { label: "Google Reviews", id: "reviews", testId: "nav-link-reviews" },
  { label: "Service Areas", id: "areas", testId: "nav-link-areas" },
  { label: "Book Now", id: "book", testId: "nav-book-now-cta-button" },
];

const img = (id, w = 1000) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("photo-1581578731548-c64695cc6952", 1200),
  residential: img("photo-1600121848594-d8644e57abab"),
  commercial: img("photo-1497366216548-37526070297c"),
  sofa: img("photo-1555041469-a586c61ea9bc"),
  kitchen: img("photo-1556911220-bff31c812dba"),
  construction: img("photo-1541888946425-d81bb19240f5"),
  before: img("photo-1584622650111-993a426fbf0a", 1400),
  after: img("photo-1560448204-e02f11c3d0e2", 1400),
};

export const SERVICES = [
  {
    icon: Home,
    testId: "service-card-residential-cleaning",
    title: "Residential Deep Cleaning",
    desc: "Top-to-bottom home resets — dusting, degreasing, machine floor scrubbing and full sanitization for every room.",
    points: ["Full-home dust & cobweb removal", "Floor, tile & grout machine scrubbing", "Windows, glass & balcony polishing"],
    image: IMAGES.residential,
  },
  {
    icon: Building2,
    testId: "service-card-commercial-facility",
    title: "Commercial & Office Sanitization",
    desc: "Scheduled facility care for offices, shops and showrooms — spotless workspaces your team and clients notice.",
    points: ["Workstation & common-area sanitization", "Washroom hygiene management", "Flexible daily / weekly contracts"],
    image: IMAGES.commercial,
  },
  {
    icon: Sofa,
    testId: "service-card-sofa-carpet",
    title: "Sofa & Carpet Shampooing",
    desc: "Injection-extraction shampooing that lifts deep-set dirt, stains and odours from upholstery and carpets.",
    points: ["Fabric-safe shampoo extraction", "Stain & odour treatment", "Quick-dry professional finish"],
    image: IMAGES.sofa,
  },
  {
    icon: CookingPot,
    testId: "service-card-kitchen-washroom",
    title: "Kitchen & Washroom Intensive Detailing",
    desc: "Grease-cutting kitchen degreasing and descaling for washrooms — the two toughest zones, handled properly.",
    points: ["Chimney, hob & tile degreasing", "Washroom descaling & disinfection", "Anti-fungal grout treatment"],
    image: IMAGES.kitchen,
  },
  {
    icon: HardHat,
    testId: "service-card-post-construction",
    title: "Post-Construction Cleanup",
    desc: "From dust-choked site to move-in ready — debris clearing, paint-spot removal and final sparkle cleaning.",
    points: ["Debris & dust extraction", "Paint, cement & adhesive spot removal", "Handover-ready final polish"],
    image: IMAGES.construction,
  },
];

export const GALLERY = [
  { src: img("photo-1584820927498-cfe5211fd8bf"), cat: "Detailing", label: "Surface sanitization" },
  { src: img("photo-1600585154340-be6161a56a0c"), cat: "Homes", label: "Villa deep clean" },
  { src: img("photo-1497366811353-6870744d04b2"), cat: "Commercial", label: "Office facility care" },
  { src: img("photo-1586023492125-27b2c045efd7"), cat: "Homes", label: "Upholstery refresh" },
  { src: img("photo-1528740561666-dc2479dc08ab"), cat: "Detailing", label: "Glass & facade shine" },
  { src: img("photo-1600607687939-ce8a6c25118c"), cat: "Homes", label: "Apartment turnover" },
  { src: img("photo-1563453392212-326f5e854473"), cat: "Detailing", label: "Pro-grade kit" },
  { src: img("photo-1497366754035-f200968a6e72"), cat: "Commercial", label: "Workspace reset" },
];

export const GALLERY_FILTERS = ["All", "Homes", "Commercial", "Detailing"];

export const REVIEWS = [
  {
    name: "Priya Sharma",
    area: "Sevoke Road, Siliguri",
    text: "Booked a full home deep clean before Diwali. The team arrived on time with all equipment and left every corner spotless — even the window tracks. Worth every rupee.",
    service: "Residential Deep Cleaning",
  },
  {
    name: "Rahul Agarwal",
    area: "Pradhan Nagar, Siliguri",
    text: "Our office of 20+ workstations gets weekly sanitization from swaclean. Professional crew, zero disruption to work, and the washrooms have never been this well maintained.",
    service: "Commercial Sanitization",
  },
  {
    name: "Anjali Das",
    area: "Matigara, Siliguri",
    text: "My 5-year-old sofa looks brand new after their shampooing service. They removed stains I had given up on. Very polite staff and transparent pricing.",
    service: "Sofa & Carpet Shampooing",
  },
  {
    name: "Vikash Kumar",
    area: "Hakimpara, Siliguri",
    text: "Hired them after our flat renovation. Cement dust, paint spots, debris — everything cleared in one day. The flat was genuinely move-in ready.",
    service: "Post-Construction Cleanup",
  },
  {
    name: "Sunita Rai",
    area: "Ashrampara, Siliguri",
    text: "Kitchen and washroom detailing was outstanding. Years of grease gone from the chimney and tiles. They use proper machines, not just mops. Highly recommended.",
    service: "Kitchen & Washroom Detailing",
  },
  {
    name: "Deepak Mondal",
    area: "Bagdogra",
    text: "Reliable, punctual and thorough. They handle our showroom's facility needs end to end. The 4.9 rating is completely deserved — booking again this month.",
    service: "Facility Management",
  },
];

export const FAQS = [
  {
    q: "Are your cleaning chemicals safe for children and pets?",
    a: "Yes. We use hospital-grade yet non-toxic, eco-certified agents. Your family and pets can re-enter most spaces within 30–60 minutes of treatment.",
  },
  {
    q: "How far in advance should I book?",
    a: "Most slots are available within the same week. For weekends and post-construction jobs we recommend booking 2–3 days ahead via the form or WhatsApp.",
  },
  {
    q: "Do you bring your own equipment and supplies?",
    a: "Absolutely. Our crew arrives with industrial scrubbers, extraction machines, microfiber kits and all chemicals — you don't need to arrange anything.",
  },
  {
    q: "How is pricing calculated?",
    a: "Pricing depends on area (sq. ft.), service type and condition of the space. Share details on the form or WhatsApp and we send a free, no-obligation quote — often the same day.",
  },
  {
    q: "Do you handle post-construction debris?",
    a: "Yes. Our post-construction package includes debris clearing, fine-dust extraction, paint and cement spot removal, and a final handover-ready polish.",
  },
  {
    q: "Which areas do you cover?",
    a: "All of Siliguri — Sevoke Road, Matigara, Pradhan Nagar, Ashrampara, Hakimpara, Salugara, Champasari, Fulbari — plus Bagdogra and Jalpaiguri on request.",
  },
];

export const AREAS = [
  "Sevoke Road",
  "Matigara",
  "Pradhan Nagar",
  "Ashrampara",
  "Hakimpara",
  "Bankim Nagar",
  "Salugara",
  "Champasari",
  "Fulbari",
  "Bagdogra",
  "Siliguri Junction",
  "Jalpaiguri",
];
